/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AdminRouteImport } from './routes/_admin'
import { Route as AppRouteImport } from './routes/_app'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as AdminAdminRouteImport } from './routes/_admin/admin'
import { Route as AppDashboardRouteImport } from './routes/_app/dashboard'
import { Route as AppNotificationsRouteImport } from './routes/_app/notifications'
import { Route as AppSettingsRouteImport } from './routes/_app/settings'
import { Route as AuthCheckEmailRouteImport } from './routes/_auth/check-email'
import { Route as AuthForgotPasswordRouteImport } from './routes/_auth/forgot-password'
import { Route as AuthOauthCompleteRouteImport } from './routes/_auth/oauth-complete'
import { Route as AuthResetPasswordRouteImport } from './routes/_auth/reset-password'
import { Route as AuthSignInRouteImport } from './routes/_auth/sign-in'
import { Route as AuthSignUpRouteImport } from './routes/_auth/sign-up'
import { Route as AuthVerifyEmailRouteImport } from './routes/_auth/verify-email'
import { Route as AgencySlugRouteImport } from './routes/agency/$slug'
import { Route as AdminAdminIndexRouteImport } from './routes/_admin/admin/index'
import { Route as AdminAdminAiCostsRouteImport } from './routes/_admin/admin/ai-costs'
import { Route as AdminAdminDelaysRouteImport } from './routes/_admin/admin/delays'
import { Route as AdminAdminDisputesRouteImport } from './routes/_admin/admin/disputes'
import { Route as AdminAdminGhostRouteImport } from './routes/_admin/admin/ghost'
import { Route as AdminAdminGrantsRouteImport } from './routes/_admin/admin/grants'
import { Route as AdminAdminModerationRouteImport } from './routes/_admin/admin/moderation'
import { Route as AdminAdminOverridesRouteImport } from './routes/_admin/admin/overrides'
import { Route as AdminAdminPromosRouteImport } from './routes/_admin/admin/promos'
import { Route as AdminAdminQuotasRouteImport } from './routes/_admin/admin/quotas'
import { Route as AdminAdminReferralsRouteImport } from './routes/_admin/admin/referrals'
import { Route as AdminAdminScoringRouteImport } from './routes/_admin/admin/scoring'
import { Route as AdminAdminUsersRouteImport } from './routes/_admin/admin/users'
import { Route as AdminAdminVerificationsRouteImport } from './routes/_admin/admin/verifications'
import { Route as AppDashboardIndexRouteImport } from './routes/_app/dashboard/index'
import { Route as AppDashboardRequesterRouteImport } from './routes/_app/dashboard/requester'
import { Route as AppOffersIndexRouteImport } from './routes/_app/offers/index'
import { Route as AppOffersNewRouteImport } from './routes/_app/offers/new'
import { Route as AppProjectsIndexRouteImport } from './routes/_app/projects/index'
import { Route as AppSettingsIndexRouteImport } from './routes/_app/settings/index'
import { Route as AppSettingsIdentityRouteImport } from './routes/_app/settings/identity'
import { Route as AppSettingsNotificationsRouteImport } from './routes/_app/settings/notifications'
import { Route as AppSettingsPlanRouteImport } from './routes/_app/settings/plan'
import { Route as AppSettingsPrivacyRouteImport } from './routes/_app/settings/privacy'
import { Route as AppSettingsPromoRouteImport } from './routes/_app/settings/promo'
import { Route as AppSettingsReferralRouteImport } from './routes/_app/settings/referral'
import { Route as AppSettingsSecurityRouteImport } from './routes/_app/settings/security'
import { Route as QuotesIdVerifyRouteImport } from './routes/quotes/$id/verify'
import { Route as AdminAdminDisputesDisputeIdRouteImport } from './routes/_admin/admin/disputes_.$disputeId'
import { Route as AppBidsBidIdDecisionRouteImport } from './routes/_app/bids/$bidId/decision'
import { Route as AppDashboardBidderBidsRouteImport } from './routes/_app/dashboard/bidder/bids'
import { Route as AppDashboardBidderCompanyRouteImport } from './routes/_app/dashboard/bidder/company'
import { Route as AppDashboardBidderFeedRouteImport } from './routes/_app/dashboard/bidder/feed'
import { Route as AppDashboardBidderIndividualRouteImport } from './routes/_app/dashboard/bidder/individual'
import { Route as AppOffersIdIndexRouteImport } from './routes/_app/offers/$id/index'
import { Route as AppOffersIdBidRouteImport } from './routes/_app/offers/$id/bid'
import { Route as AppOffersIdEditRouteImport } from './routes/_app/offers/$id/edit'
import { Route as AppOffersIdSelectionRouteImport } from './routes/_app/offers/$id/selection'
import { Route as AppProfileBidderCompanyRouteImport } from './routes/_app/profile/bidder/company'
import { Route as AppProfileBidderIndividualRouteImport } from './routes/_app/profile/bidder/individual'
import { Route as AppProjectsIdIndexRouteImport } from './routes/_app/projects/$id/index'
import { Route as AppProjectsIdCalendarRouteImport } from './routes/_app/projects/$id/calendar'
import { Route as AppProjectsIdDisputeRouteImport } from './routes/_app/projects/$id/dispute'
import { Route as AppProjectsIdRatingRouteImport } from './routes/_app/projects/$id/rating'
import { Route as AppProjectsIdTasksRouteImport } from './routes/_app/projects/$id/tasks'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRoute = AdminRouteImport.update({
  id: '/_admin',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminAdminRoute = AdminAdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => AdminRoute,
} as any)
const AppDashboardRoute = AppDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AppRoute,
} as any)
const AppNotificationsRoute = AppNotificationsRouteImport.update({
  id: '/notifications',
  path: '/notifications',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsRoute = AppSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppRoute,
} as any)
const AuthCheckEmailRoute = AuthCheckEmailRouteImport.update({
  id: '/check-email',
  path: '/check-email',
  getParentRoute: () => AuthRoute,
} as any)
const AuthForgotPasswordRoute = AuthForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => AuthRoute,
} as any)
const AuthOauthCompleteRoute = AuthOauthCompleteRouteImport.update({
  id: '/oauth-complete',
  path: '/oauth-complete',
  getParentRoute: () => AuthRoute,
} as any)
const AuthResetPasswordRoute = AuthResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSignInRoute = AuthSignInRouteImport.update({
  id: '/sign-in',
  path: '/sign-in',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSignUpRoute = AuthSignUpRouteImport.update({
  id: '/sign-up',
  path: '/sign-up',
  getParentRoute: () => AuthRoute,
} as any)
const AuthVerifyEmailRoute = AuthVerifyEmailRouteImport.update({
  id: '/verify-email',
  path: '/verify-email',
  getParentRoute: () => AuthRoute,
} as any)
const AgencySlugRoute = AgencySlugRouteImport.update({
  id: '/agency/$slug',
  path: '/agency/$slug',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminAdminIndexRoute = AdminAdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminAdminRoute,
} as any)
const AdminAdminAiCostsRoute = AdminAdminAiCostsRouteImport.update({
  id: '/ai-costs',
  path: '/ai-costs',
  getParentRoute: () => AdminAdminRoute,
} as any)
const AdminAdminDelaysRoute = AdminAdminDelaysRouteImport.update({
  id: '/delays',
  path: '/delays',
  getParentRoute: () => AdminAdminRoute,
} as any)
const AdminAdminDisputesRoute = AdminAdminDisputesRouteImport.update({
  id: '/disputes',
  path: '/disputes',
  getParentRoute: () => AdminAdminRoute,
} as any)
const AdminAdminGhostRoute = AdminAdminGhostRouteImport.update({
  id: '/ghost',
  path: '/ghost',
  getParentRoute: () => AdminAdminRoute,
} as any)
const AdminAdminGrantsRoute = AdminAdminGrantsRouteImport.update({
  id: '/grants',
  path: '/grants',
  getParentRoute: () => AdminAdminRoute,
} as any)
const AdminAdminModerationRoute = AdminAdminModerationRouteImport.update({
  id: '/moderation',
  path: '/moderation',
  getParentRoute: () => AdminAdminRoute,
} as any)
const AdminAdminOverridesRoute = AdminAdminOverridesRouteImport.update({
  id: '/overrides',
  path: '/overrides',
  getParentRoute: () => AdminAdminRoute,
} as any)
const AdminAdminPromosRoute = AdminAdminPromosRouteImport.update({
  id: '/promos',
  path: '/promos',
  getParentRoute: () => AdminAdminRoute,
} as any)
const AdminAdminQuotasRoute = AdminAdminQuotasRouteImport.update({
  id: '/quotas',
  path: '/quotas',
  getParentRoute: () => AdminAdminRoute,
} as any)
const AdminAdminReferralsRoute = AdminAdminReferralsRouteImport.update({
  id: '/referrals',
  path: '/referrals',
  getParentRoute: () => AdminAdminRoute,
} as any)
const AdminAdminScoringRoute = AdminAdminScoringRouteImport.update({
  id: '/scoring',
  path: '/scoring',
  getParentRoute: () => AdminAdminRoute,
} as any)
const AdminAdminUsersRoute = AdminAdminUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AdminAdminRoute,
} as any)
const AdminAdminVerificationsRoute = AdminAdminVerificationsRouteImport.update({
  id: '/verifications',
  path: '/verifications',
  getParentRoute: () => AdminAdminRoute,
} as any)
const AppDashboardIndexRoute = AppDashboardIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppDashboardRoute,
} as any)
const AppDashboardRequesterRoute = AppDashboardRequesterRouteImport.update({
  id: '/requester',
  path: '/requester',
  getParentRoute: () => AppDashboardRoute,
} as any)
const AppOffersIndexRoute = AppOffersIndexRouteImport.update({
  id: '/offers/',
  path: '/offers/',
  getParentRoute: () => AppRoute,
} as any)
const AppOffersNewRoute = AppOffersNewRouteImport.update({
  id: '/offers/new',
  path: '/offers/new',
  getParentRoute: () => AppRoute,
} as any)
const AppProjectsIndexRoute = AppProjectsIndexRouteImport.update({
  id: '/projects/',
  path: '/projects/',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsIndexRoute = AppSettingsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsIdentityRoute = AppSettingsIdentityRouteImport.update({
  id: '/identity',
  path: '/identity',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsNotificationsRoute =
  AppSettingsNotificationsRouteImport.update({
    id: '/notifications',
    path: '/notifications',
    getParentRoute: () => AppSettingsRoute,
  } as any)
const AppSettingsPlanRoute = AppSettingsPlanRouteImport.update({
  id: '/plan',
  path: '/plan',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsPrivacyRoute = AppSettingsPrivacyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsPromoRoute = AppSettingsPromoRouteImport.update({
  id: '/promo',
  path: '/promo',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsReferralRoute = AppSettingsReferralRouteImport.update({
  id: '/referral',
  path: '/referral',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsSecurityRoute = AppSettingsSecurityRouteImport.update({
  id: '/security',
  path: '/security',
  getParentRoute: () => AppSettingsRoute,
} as any)
const QuotesIdVerifyRoute = QuotesIdVerifyRouteImport.update({
  id: '/quotes/$id/verify',
  path: '/quotes/$id/verify',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminAdminDisputesDisputeIdRoute =
  AdminAdminDisputesDisputeIdRouteImport.update({
    id: '/disputes_/$disputeId',
    path: '/disputes/$disputeId',
    getParentRoute: () => AdminAdminRoute,
  } as any)
const AppBidsBidIdDecisionRoute = AppBidsBidIdDecisionRouteImport.update({
  id: '/bids/$bidId/decision',
  path: '/bids/$bidId/decision',
  getParentRoute: () => AppRoute,
} as any)
const AppDashboardBidderBidsRoute = AppDashboardBidderBidsRouteImport.update({
  id: '/bidder/bids',
  path: '/bidder/bids',
  getParentRoute: () => AppDashboardRoute,
} as any)
const AppDashboardBidderCompanyRoute =
  AppDashboardBidderCompanyRouteImport.update({
    id: '/bidder/company',
    path: '/bidder/company',
    getParentRoute: () => AppDashboardRoute,
  } as any)
const AppDashboardBidderFeedRoute = AppDashboardBidderFeedRouteImport.update({
  id: '/bidder/feed',
  path: '/bidder/feed',
  getParentRoute: () => AppDashboardRoute,
} as any)
const AppDashboardBidderIndividualRoute =
  AppDashboardBidderIndividualRouteImport.update({
    id: '/bidder/individual',
    path: '/bidder/individual',
    getParentRoute: () => AppDashboardRoute,
  } as any)
const AppOffersIdIndexRoute = AppOffersIdIndexRouteImport.update({
  id: '/offers/$id/',
  path: '/offers/$id/',
  getParentRoute: () => AppRoute,
} as any)
const AppOffersIdBidRoute = AppOffersIdBidRouteImport.update({
  id: '/offers/$id/bid',
  path: '/offers/$id/bid',
  getParentRoute: () => AppRoute,
} as any)
const AppOffersIdEditRoute = AppOffersIdEditRouteImport.update({
  id: '/offers/$id/edit',
  path: '/offers/$id/edit',
  getParentRoute: () => AppRoute,
} as any)
const AppOffersIdSelectionRoute = AppOffersIdSelectionRouteImport.update({
  id: '/offers/$id/selection',
  path: '/offers/$id/selection',
  getParentRoute: () => AppRoute,
} as any)
const AppProfileBidderCompanyRoute = AppProfileBidderCompanyRouteImport.update({
  id: '/profile/bidder/company',
  path: '/profile/bidder/company',
  getParentRoute: () => AppRoute,
} as any)
const AppProfileBidderIndividualRoute =
  AppProfileBidderIndividualRouteImport.update({
    id: '/profile/bidder/individual',
    path: '/profile/bidder/individual',
    getParentRoute: () => AppRoute,
  } as any)
const AppProjectsIdIndexRoute = AppProjectsIdIndexRouteImport.update({
  id: '/projects/$id/',
  path: '/projects/$id/',
  getParentRoute: () => AppRoute,
} as any)
const AppProjectsIdCalendarRoute = AppProjectsIdCalendarRouteImport.update({
  id: '/projects/$id/calendar',
  path: '/projects/$id/calendar',
  getParentRoute: () => AppRoute,
} as any)
const AppProjectsIdDisputeRoute = AppProjectsIdDisputeRouteImport.update({
  id: '/projects/$id/dispute',
  path: '/projects/$id/dispute',
  getParentRoute: () => AppRoute,
} as any)
const AppProjectsIdRatingRoute = AppProjectsIdRatingRouteImport.update({
  id: '/projects/$id/rating',
  path: '/projects/$id/rating',
  getParentRoute: () => AppRoute,
} as any)
const AppProjectsIdTasksRoute = AppProjectsIdTasksRouteImport.update({
  id: '/projects/$id/tasks',
  path: '/projects/$id/tasks',
  getParentRoute: () => AppRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/admin': typeof AdminAdminRouteWithChildren
  '/dashboard': typeof AppDashboardRouteWithChildren
  '/notifications': typeof AppNotificationsRoute
  '/settings': typeof AppSettingsRouteWithChildren
  '/check-email': typeof AuthCheckEmailRoute
  '/forgot-password': typeof AuthForgotPasswordRoute
  '/oauth-complete': typeof AuthOauthCompleteRoute
  '/reset-password': typeof AuthResetPasswordRoute
  '/sign-in': typeof AuthSignInRoute
  '/sign-up': typeof AuthSignUpRoute
  '/verify-email': typeof AuthVerifyEmailRoute
  '/agency/$slug': typeof AgencySlugRoute
  '/admin/ai-costs': typeof AdminAdminAiCostsRoute
  '/admin/delays': typeof AdminAdminDelaysRoute
  '/admin/disputes': typeof AdminAdminDisputesRoute
  '/admin/ghost': typeof AdminAdminGhostRoute
  '/admin/grants': typeof AdminAdminGrantsRoute
  '/admin/moderation': typeof AdminAdminModerationRoute
  '/admin/overrides': typeof AdminAdminOverridesRoute
  '/admin/promos': typeof AdminAdminPromosRoute
  '/admin/quotas': typeof AdminAdminQuotasRoute
  '/admin/referrals': typeof AdminAdminReferralsRoute
  '/admin/scoring': typeof AdminAdminScoringRoute
  '/admin/users': typeof AdminAdminUsersRoute
  '/admin/verifications': typeof AdminAdminVerificationsRoute
  '/dashboard/requester': typeof AppDashboardRequesterRoute
  '/offers/new': typeof AppOffersNewRoute
  '/settings/identity': typeof AppSettingsIdentityRoute
  '/settings/notifications': typeof AppSettingsNotificationsRoute
  '/settings/plan': typeof AppSettingsPlanRoute
  '/settings/privacy': typeof AppSettingsPrivacyRoute
  '/settings/promo': typeof AppSettingsPromoRoute
  '/settings/referral': typeof AppSettingsReferralRoute
  '/settings/security': typeof AppSettingsSecurityRoute
  '/quotes/$id/verify': typeof QuotesIdVerifyRoute
  '/admin/': typeof AdminAdminIndexRoute
  '/dashboard/': typeof AppDashboardIndexRoute
  '/offers/': typeof AppOffersIndexRoute
  '/projects/': typeof AppProjectsIndexRoute
  '/settings/': typeof AppSettingsIndexRoute
  '/admin/disputes/$disputeId': typeof AdminAdminDisputesDisputeIdRoute
  '/bids/$bidId/decision': typeof AppBidsBidIdDecisionRoute
  '/dashboard/bidder/bids': typeof AppDashboardBidderBidsRoute
  '/dashboard/bidder/company': typeof AppDashboardBidderCompanyRoute
  '/dashboard/bidder/feed': typeof AppDashboardBidderFeedRoute
  '/dashboard/bidder/individual': typeof AppDashboardBidderIndividualRoute
  '/offers/$id/bid': typeof AppOffersIdBidRoute
  '/offers/$id/edit': typeof AppOffersIdEditRoute
  '/offers/$id/selection': typeof AppOffersIdSelectionRoute
  '/profile/bidder/company': typeof AppProfileBidderCompanyRoute
  '/profile/bidder/individual': typeof AppProfileBidderIndividualRoute
  '/projects/$id/calendar': typeof AppProjectsIdCalendarRoute
  '/projects/$id/dispute': typeof AppProjectsIdDisputeRoute
  '/projects/$id/rating': typeof AppProjectsIdRatingRoute
  '/projects/$id/tasks': typeof AppProjectsIdTasksRoute
  '/offers/$id/': typeof AppOffersIdIndexRoute
  '/projects/$id/': typeof AppProjectsIdIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/notifications': typeof AppNotificationsRoute
  '/check-email': typeof AuthCheckEmailRoute
  '/forgot-password': typeof AuthForgotPasswordRoute
  '/oauth-complete': typeof AuthOauthCompleteRoute
  '/reset-password': typeof AuthResetPasswordRoute
  '/sign-in': typeof AuthSignInRoute
  '/sign-up': typeof AuthSignUpRoute
  '/verify-email': typeof AuthVerifyEmailRoute
  '/agency/$slug': typeof AgencySlugRoute
  '/admin/ai-costs': typeof AdminAdminAiCostsRoute
  '/admin/delays': typeof AdminAdminDelaysRoute
  '/admin/disputes': typeof AdminAdminDisputesRoute
  '/admin/ghost': typeof AdminAdminGhostRoute
  '/admin/grants': typeof AdminAdminGrantsRoute
  '/admin/moderation': typeof AdminAdminModerationRoute
  '/admin/overrides': typeof AdminAdminOverridesRoute
  '/admin/promos': typeof AdminAdminPromosRoute
  '/admin/quotas': typeof AdminAdminQuotasRoute
  '/admin/referrals': typeof AdminAdminReferralsRoute
  '/admin/scoring': typeof AdminAdminScoringRoute
  '/admin/users': typeof AdminAdminUsersRoute
  '/admin/verifications': typeof AdminAdminVerificationsRoute
  '/dashboard/requester': typeof AppDashboardRequesterRoute
  '/offers/new': typeof AppOffersNewRoute
  '/settings/identity': typeof AppSettingsIdentityRoute
  '/settings/notifications': typeof AppSettingsNotificationsRoute
  '/settings/plan': typeof AppSettingsPlanRoute
  '/settings/privacy': typeof AppSettingsPrivacyRoute
  '/settings/promo': typeof AppSettingsPromoRoute
  '/settings/referral': typeof AppSettingsReferralRoute
  '/settings/security': typeof AppSettingsSecurityRoute
  '/quotes/$id/verify': typeof QuotesIdVerifyRoute
  '/admin': typeof AdminAdminIndexRoute
  '/dashboard': typeof AppDashboardIndexRoute
  '/offers': typeof AppOffersIndexRoute
  '/projects': typeof AppProjectsIndexRoute
  '/settings': typeof AppSettingsIndexRoute
  '/admin/disputes/$disputeId': typeof AdminAdminDisputesDisputeIdRoute
  '/bids/$bidId/decision': typeof AppBidsBidIdDecisionRoute
  '/dashboard/bidder/bids': typeof AppDashboardBidderBidsRoute
  '/dashboard/bidder/company': typeof AppDashboardBidderCompanyRoute
  '/dashboard/bidder/feed': typeof AppDashboardBidderFeedRoute
  '/dashboard/bidder/individual': typeof AppDashboardBidderIndividualRoute
  '/offers/$id/bid': typeof AppOffersIdBidRoute
  '/offers/$id/edit': typeof AppOffersIdEditRoute
  '/offers/$id/selection': typeof AppOffersIdSelectionRoute
  '/profile/bidder/company': typeof AppProfileBidderCompanyRoute
  '/profile/bidder/individual': typeof AppProfileBidderIndividualRoute
  '/projects/$id/calendar': typeof AppProjectsIdCalendarRoute
  '/projects/$id/dispute': typeof AppProjectsIdDisputeRoute
  '/projects/$id/rating': typeof AppProjectsIdRatingRoute
  '/projects/$id/tasks': typeof AppProjectsIdTasksRoute
  '/offers/$id': typeof AppOffersIdIndexRoute
  '/projects/$id': typeof AppProjectsIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_admin': typeof AdminRouteWithChildren
  '/_app': typeof AppRouteWithChildren
  '/_auth': typeof AuthRouteWithChildren
  '/_admin/admin': typeof AdminAdminRouteWithChildren
  '/_app/dashboard': typeof AppDashboardRouteWithChildren
  '/_app/notifications': typeof AppNotificationsRoute
  '/_app/settings': typeof AppSettingsRouteWithChildren
  '/_auth/check-email': typeof AuthCheckEmailRoute
  '/_auth/forgot-password': typeof AuthForgotPasswordRoute
  '/_auth/oauth-complete': typeof AuthOauthCompleteRoute
  '/_auth/reset-password': typeof AuthResetPasswordRoute
  '/_auth/sign-in': typeof AuthSignInRoute
  '/_auth/sign-up': typeof AuthSignUpRoute
  '/_auth/verify-email': typeof AuthVerifyEmailRoute
  '/agency/$slug': typeof AgencySlugRoute
  '/_admin/admin/ai-costs': typeof AdminAdminAiCostsRoute
  '/_admin/admin/delays': typeof AdminAdminDelaysRoute
  '/_admin/admin/disputes': typeof AdminAdminDisputesRoute
  '/_admin/admin/ghost': typeof AdminAdminGhostRoute
  '/_admin/admin/grants': typeof AdminAdminGrantsRoute
  '/_admin/admin/moderation': typeof AdminAdminModerationRoute
  '/_admin/admin/overrides': typeof AdminAdminOverridesRoute
  '/_admin/admin/promos': typeof AdminAdminPromosRoute
  '/_admin/admin/quotas': typeof AdminAdminQuotasRoute
  '/_admin/admin/referrals': typeof AdminAdminReferralsRoute
  '/_admin/admin/scoring': typeof AdminAdminScoringRoute
  '/_admin/admin/users': typeof AdminAdminUsersRoute
  '/_admin/admin/verifications': typeof AdminAdminVerificationsRoute
  '/_app/dashboard/requester': typeof AppDashboardRequesterRoute
  '/_app/offers/new': typeof AppOffersNewRoute
  '/_app/settings/identity': typeof AppSettingsIdentityRoute
  '/_app/settings/notifications': typeof AppSettingsNotificationsRoute
  '/_app/settings/plan': typeof AppSettingsPlanRoute
  '/_app/settings/privacy': typeof AppSettingsPrivacyRoute
  '/_app/settings/promo': typeof AppSettingsPromoRoute
  '/_app/settings/referral': typeof AppSettingsReferralRoute
  '/_app/settings/security': typeof AppSettingsSecurityRoute
  '/quotes/$id/verify': typeof QuotesIdVerifyRoute
  '/_admin/admin/': typeof AdminAdminIndexRoute
  '/_app/dashboard/': typeof AppDashboardIndexRoute
  '/_app/offers/': typeof AppOffersIndexRoute
  '/_app/projects/': typeof AppProjectsIndexRoute
  '/_app/settings/': typeof AppSettingsIndexRoute
  '/_admin/admin/disputes_/$disputeId': typeof AdminAdminDisputesDisputeIdRoute
  '/_app/bids/$bidId/decision': typeof AppBidsBidIdDecisionRoute
  '/_app/dashboard/bidder/bids': typeof AppDashboardBidderBidsRoute
  '/_app/dashboard/bidder/company': typeof AppDashboardBidderCompanyRoute
  '/_app/dashboard/bidder/feed': typeof AppDashboardBidderFeedRoute
  '/_app/dashboard/bidder/individual': typeof AppDashboardBidderIndividualRoute
  '/_app/offers/$id/bid': typeof AppOffersIdBidRoute
  '/_app/offers/$id/edit': typeof AppOffersIdEditRoute
  '/_app/offers/$id/selection': typeof AppOffersIdSelectionRoute
  '/_app/profile/bidder/company': typeof AppProfileBidderCompanyRoute
  '/_app/profile/bidder/individual': typeof AppProfileBidderIndividualRoute
  '/_app/projects/$id/calendar': typeof AppProjectsIdCalendarRoute
  '/_app/projects/$id/dispute': typeof AppProjectsIdDisputeRoute
  '/_app/projects/$id/rating': typeof AppProjectsIdRatingRoute
  '/_app/projects/$id/tasks': typeof AppProjectsIdTasksRoute
  '/_app/offers/$id/': typeof AppOffersIdIndexRoute
  '/_app/projects/$id/': typeof AppProjectsIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/admin'
    | '/dashboard'
    | '/notifications'
    | '/settings'
    | '/check-email'
    | '/forgot-password'
    | '/oauth-complete'
    | '/reset-password'
    | '/sign-in'
    | '/sign-up'
    | '/verify-email'
    | '/agency/$slug'
    | '/admin/ai-costs'
    | '/admin/delays'
    | '/admin/disputes'
    | '/admin/ghost'
    | '/admin/grants'
    | '/admin/moderation'
    | '/admin/overrides'
    | '/admin/promos'
    | '/admin/quotas'
    | '/admin/referrals'
    | '/admin/scoring'
    | '/admin/users'
    | '/admin/verifications'
    | '/dashboard/requester'
    | '/offers/new'
    | '/settings/identity'
    | '/settings/notifications'
    | '/settings/plan'
    | '/settings/privacy'
    | '/settings/promo'
    | '/settings/referral'
    | '/settings/security'
    | '/quotes/$id/verify'
    | '/admin/'
    | '/dashboard/'
    | '/offers/'
    | '/projects/'
    | '/settings/'
    | '/admin/disputes/$disputeId'
    | '/bids/$bidId/decision'
    | '/dashboard/bidder/bids'
    | '/dashboard/bidder/company'
    | '/dashboard/bidder/feed'
    | '/dashboard/bidder/individual'
    | '/offers/$id/bid'
    | '/offers/$id/edit'
    | '/offers/$id/selection'
    | '/profile/bidder/company'
    | '/profile/bidder/individual'
    | '/projects/$id/calendar'
    | '/projects/$id/dispute'
    | '/projects/$id/rating'
    | '/projects/$id/tasks'
    | '/offers/$id/'
    | '/projects/$id/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/notifications'
    | '/check-email'
    | '/forgot-password'
    | '/oauth-complete'
    | '/reset-password'
    | '/sign-in'
    | '/sign-up'
    | '/verify-email'
    | '/agency/$slug'
    | '/admin/ai-costs'
    | '/admin/delays'
    | '/admin/disputes'
    | '/admin/ghost'
    | '/admin/grants'
    | '/admin/moderation'
    | '/admin/overrides'
    | '/admin/promos'
    | '/admin/quotas'
    | '/admin/referrals'
    | '/admin/scoring'
    | '/admin/users'
    | '/admin/verifications'
    | '/dashboard/requester'
    | '/offers/new'
    | '/settings/identity'
    | '/settings/notifications'
    | '/settings/plan'
    | '/settings/privacy'
    | '/settings/promo'
    | '/settings/referral'
    | '/settings/security'
    | '/quotes/$id/verify'
    | '/admin'
    | '/dashboard'
    | '/offers'
    | '/projects'
    | '/settings'
    | '/admin/disputes/$disputeId'
    | '/bids/$bidId/decision'
    | '/dashboard/bidder/bids'
    | '/dashboard/bidder/company'
    | '/dashboard/bidder/feed'
    | '/dashboard/bidder/individual'
    | '/offers/$id/bid'
    | '/offers/$id/edit'
    | '/offers/$id/selection'
    | '/profile/bidder/company'
    | '/profile/bidder/individual'
    | '/projects/$id/calendar'
    | '/projects/$id/dispute'
    | '/projects/$id/rating'
    | '/projects/$id/tasks'
    | '/offers/$id'
    | '/projects/$id'
  id:
    | '__root__'
    | '/'
    | '/_admin'
    | '/_app'
    | '/_auth'
    | '/_admin/admin'
    | '/_app/dashboard'
    | '/_app/notifications'
    | '/_app/settings'
    | '/_auth/check-email'
    | '/_auth/forgot-password'
    | '/_auth/oauth-complete'
    | '/_auth/reset-password'
    | '/_auth/sign-in'
    | '/_auth/sign-up'
    | '/_auth/verify-email'
    | '/agency/$slug'
    | '/_admin/admin/ai-costs'
    | '/_admin/admin/delays'
    | '/_admin/admin/disputes'
    | '/_admin/admin/ghost'
    | '/_admin/admin/grants'
    | '/_admin/admin/moderation'
    | '/_admin/admin/overrides'
    | '/_admin/admin/promos'
    | '/_admin/admin/quotas'
    | '/_admin/admin/referrals'
    | '/_admin/admin/scoring'
    | '/_admin/admin/users'
    | '/_admin/admin/verifications'
    | '/_app/dashboard/requester'
    | '/_app/offers/new'
    | '/_app/settings/identity'
    | '/_app/settings/notifications'
    | '/_app/settings/plan'
    | '/_app/settings/privacy'
    | '/_app/settings/promo'
    | '/_app/settings/referral'
    | '/_app/settings/security'
    | '/quotes/$id/verify'
    | '/_admin/admin/'
    | '/_app/dashboard/'
    | '/_app/offers/'
    | '/_app/projects/'
    | '/_app/settings/'
    | '/_admin/admin/disputes_/$disputeId'
    | '/_app/bids/$bidId/decision'
    | '/_app/dashboard/bidder/bids'
    | '/_app/dashboard/bidder/company'
    | '/_app/dashboard/bidder/feed'
    | '/_app/dashboard/bidder/individual'
    | '/_app/offers/$id/bid'
    | '/_app/offers/$id/edit'
    | '/_app/offers/$id/selection'
    | '/_app/profile/bidder/company'
    | '/_app/profile/bidder/individual'
    | '/_app/projects/$id/calendar'
    | '/_app/projects/$id/dispute'
    | '/_app/projects/$id/rating'
    | '/_app/projects/$id/tasks'
    | '/_app/offers/$id/'
    | '/_app/projects/$id/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AdminRoute: typeof AdminRouteWithChildren
  AppRoute: typeof AppRouteWithChildren
  AuthRoute: typeof AuthRouteWithChildren
  AgencySlugRoute: typeof AgencySlugRoute
  QuotesIdVerifyRoute: typeof QuotesIdVerifyRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_admin': {
      id: '/_admin'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_admin/admin': {
      id: '/_admin/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminAdminRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_app/dashboard': {
      id: '/_app/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AppDashboardRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/notifications': {
      id: '/_app/notifications'
      path: '/notifications'
      fullPath: '/notifications'
      preLoaderRoute: typeof AppNotificationsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings': {
      id: '/_app/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AppSettingsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_auth/check-email': {
      id: '/_auth/check-email'
      path: '/check-email'
      fullPath: '/check-email'
      preLoaderRoute: typeof AuthCheckEmailRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/forgot-password': {
      id: '/_auth/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof AuthForgotPasswordRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/oauth-complete': {
      id: '/_auth/oauth-complete'
      path: '/oauth-complete'
      fullPath: '/oauth-complete'
      preLoaderRoute: typeof AuthOauthCompleteRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/reset-password': {
      id: '/_auth/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof AuthResetPasswordRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/sign-in': {
      id: '/_auth/sign-in'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof AuthSignInRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/sign-up': {
      id: '/_auth/sign-up'
      path: '/sign-up'
      fullPath: '/sign-up'
      preLoaderRoute: typeof AuthSignUpRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/verify-email': {
      id: '/_auth/verify-email'
      path: '/verify-email'
      fullPath: '/verify-email'
      preLoaderRoute: typeof AuthVerifyEmailRouteImport
      parentRoute: typeof AuthRoute
    }
    '/agency/$slug': {
      id: '/agency/$slug'
      path: '/agency/$slug'
      fullPath: '/agency/$slug'
      preLoaderRoute: typeof AgencySlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_admin/admin/': {
      id: '/_admin/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AdminAdminIndexRouteImport
      parentRoute: typeof AdminAdminRoute
    }
    '/_admin/admin/ai-costs': {
      id: '/_admin/admin/ai-costs'
      path: '/ai-costs'
      fullPath: '/admin/ai-costs'
      preLoaderRoute: typeof AdminAdminAiCostsRouteImport
      parentRoute: typeof AdminAdminRoute
    }
    '/_admin/admin/delays': {
      id: '/_admin/admin/delays'
      path: '/delays'
      fullPath: '/admin/delays'
      preLoaderRoute: typeof AdminAdminDelaysRouteImport
      parentRoute: typeof AdminAdminRoute
    }
    '/_admin/admin/disputes': {
      id: '/_admin/admin/disputes'
      path: '/disputes'
      fullPath: '/admin/disputes'
      preLoaderRoute: typeof AdminAdminDisputesRouteImport
      parentRoute: typeof AdminAdminRoute
    }
    '/_admin/admin/ghost': {
      id: '/_admin/admin/ghost'
      path: '/ghost'
      fullPath: '/admin/ghost'
      preLoaderRoute: typeof AdminAdminGhostRouteImport
      parentRoute: typeof AdminAdminRoute
    }
    '/_admin/admin/grants': {
      id: '/_admin/admin/grants'
      path: '/grants'
      fullPath: '/admin/grants'
      preLoaderRoute: typeof AdminAdminGrantsRouteImport
      parentRoute: typeof AdminAdminRoute
    }
    '/_admin/admin/moderation': {
      id: '/_admin/admin/moderation'
      path: '/moderation'
      fullPath: '/admin/moderation'
      preLoaderRoute: typeof AdminAdminModerationRouteImport
      parentRoute: typeof AdminAdminRoute
    }
    '/_admin/admin/overrides': {
      id: '/_admin/admin/overrides'
      path: '/overrides'
      fullPath: '/admin/overrides'
      preLoaderRoute: typeof AdminAdminOverridesRouteImport
      parentRoute: typeof AdminAdminRoute
    }
    '/_admin/admin/promos': {
      id: '/_admin/admin/promos'
      path: '/promos'
      fullPath: '/admin/promos'
      preLoaderRoute: typeof AdminAdminPromosRouteImport
      parentRoute: typeof AdminAdminRoute
    }
    '/_admin/admin/quotas': {
      id: '/_admin/admin/quotas'
      path: '/quotas'
      fullPath: '/admin/quotas'
      preLoaderRoute: typeof AdminAdminQuotasRouteImport
      parentRoute: typeof AdminAdminRoute
    }
    '/_admin/admin/referrals': {
      id: '/_admin/admin/referrals'
      path: '/referrals'
      fullPath: '/admin/referrals'
      preLoaderRoute: typeof AdminAdminReferralsRouteImport
      parentRoute: typeof AdminAdminRoute
    }
    '/_admin/admin/scoring': {
      id: '/_admin/admin/scoring'
      path: '/scoring'
      fullPath: '/admin/scoring'
      preLoaderRoute: typeof AdminAdminScoringRouteImport
      parentRoute: typeof AdminAdminRoute
    }
    '/_admin/admin/users': {
      id: '/_admin/admin/users'
      path: '/users'
      fullPath: '/admin/users'
      preLoaderRoute: typeof AdminAdminUsersRouteImport
      parentRoute: typeof AdminAdminRoute
    }
    '/_admin/admin/verifications': {
      id: '/_admin/admin/verifications'
      path: '/verifications'
      fullPath: '/admin/verifications'
      preLoaderRoute: typeof AdminAdminVerificationsRouteImport
      parentRoute: typeof AdminAdminRoute
    }
    '/_app/dashboard/': {
      id: '/_app/dashboard/'
      path: '/'
      fullPath: '/dashboard/'
      preLoaderRoute: typeof AppDashboardIndexRouteImport
      parentRoute: typeof AppDashboardRoute
    }
    '/_app/dashboard/requester': {
      id: '/_app/dashboard/requester'
      path: '/requester'
      fullPath: '/dashboard/requester'
      preLoaderRoute: typeof AppDashboardRequesterRouteImport
      parentRoute: typeof AppDashboardRoute
    }
    '/_app/offers/': {
      id: '/_app/offers/'
      path: '/offers'
      fullPath: '/offers/'
      preLoaderRoute: typeof AppOffersIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/offers/new': {
      id: '/_app/offers/new'
      path: '/offers/new'
      fullPath: '/offers/new'
      preLoaderRoute: typeof AppOffersNewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/projects/': {
      id: '/_app/projects/'
      path: '/projects'
      fullPath: '/projects/'
      preLoaderRoute: typeof AppProjectsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings/': {
      id: '/_app/settings/'
      path: '/'
      fullPath: '/settings/'
      preLoaderRoute: typeof AppSettingsIndexRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/identity': {
      id: '/_app/settings/identity'
      path: '/identity'
      fullPath: '/settings/identity'
      preLoaderRoute: typeof AppSettingsIdentityRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/notifications': {
      id: '/_app/settings/notifications'
      path: '/notifications'
      fullPath: '/settings/notifications'
      preLoaderRoute: typeof AppSettingsNotificationsRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/plan': {
      id: '/_app/settings/plan'
      path: '/plan'
      fullPath: '/settings/plan'
      preLoaderRoute: typeof AppSettingsPlanRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/privacy': {
      id: '/_app/settings/privacy'
      path: '/privacy'
      fullPath: '/settings/privacy'
      preLoaderRoute: typeof AppSettingsPrivacyRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/promo': {
      id: '/_app/settings/promo'
      path: '/promo'
      fullPath: '/settings/promo'
      preLoaderRoute: typeof AppSettingsPromoRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/referral': {
      id: '/_app/settings/referral'
      path: '/referral'
      fullPath: '/settings/referral'
      preLoaderRoute: typeof AppSettingsReferralRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/security': {
      id: '/_app/settings/security'
      path: '/security'
      fullPath: '/settings/security'
      preLoaderRoute: typeof AppSettingsSecurityRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/quotes/$id/verify': {
      id: '/quotes/$id/verify'
      path: '/quotes/$id/verify'
      fullPath: '/quotes/$id/verify'
      preLoaderRoute: typeof QuotesIdVerifyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_admin/admin/disputes_/$disputeId': {
      id: '/_admin/admin/disputes_/$disputeId'
      path: '/disputes/$disputeId'
      fullPath: '/admin/disputes/$disputeId'
      preLoaderRoute: typeof AdminAdminDisputesDisputeIdRouteImport
      parentRoute: typeof AdminAdminRoute
    }
    '/_app/bids/$bidId/decision': {
      id: '/_app/bids/$bidId/decision'
      path: '/bids/$bidId/decision'
      fullPath: '/bids/$bidId/decision'
      preLoaderRoute: typeof AppBidsBidIdDecisionRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/dashboard/bidder/bids': {
      id: '/_app/dashboard/bidder/bids'
      path: '/bidder/bids'
      fullPath: '/dashboard/bidder/bids'
      preLoaderRoute: typeof AppDashboardBidderBidsRouteImport
      parentRoute: typeof AppDashboardRoute
    }
    '/_app/dashboard/bidder/company': {
      id: '/_app/dashboard/bidder/company'
      path: '/bidder/company'
      fullPath: '/dashboard/bidder/company'
      preLoaderRoute: typeof AppDashboardBidderCompanyRouteImport
      parentRoute: typeof AppDashboardRoute
    }
    '/_app/dashboard/bidder/feed': {
      id: '/_app/dashboard/bidder/feed'
      path: '/bidder/feed'
      fullPath: '/dashboard/bidder/feed'
      preLoaderRoute: typeof AppDashboardBidderFeedRouteImport
      parentRoute: typeof AppDashboardRoute
    }
    '/_app/dashboard/bidder/individual': {
      id: '/_app/dashboard/bidder/individual'
      path: '/bidder/individual'
      fullPath: '/dashboard/bidder/individual'
      preLoaderRoute: typeof AppDashboardBidderIndividualRouteImport
      parentRoute: typeof AppDashboardRoute
    }
    '/_app/offers/$id/': {
      id: '/_app/offers/$id/'
      path: '/offers/$id'
      fullPath: '/offers/$id/'
      preLoaderRoute: typeof AppOffersIdIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/offers/$id/bid': {
      id: '/_app/offers/$id/bid'
      path: '/offers/$id/bid'
      fullPath: '/offers/$id/bid'
      preLoaderRoute: typeof AppOffersIdBidRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/offers/$id/edit': {
      id: '/_app/offers/$id/edit'
      path: '/offers/$id/edit'
      fullPath: '/offers/$id/edit'
      preLoaderRoute: typeof AppOffersIdEditRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/offers/$id/selection': {
      id: '/_app/offers/$id/selection'
      path: '/offers/$id/selection'
      fullPath: '/offers/$id/selection'
      preLoaderRoute: typeof AppOffersIdSelectionRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/profile/bidder/company': {
      id: '/_app/profile/bidder/company'
      path: '/profile/bidder/company'
      fullPath: '/profile/bidder/company'
      preLoaderRoute: typeof AppProfileBidderCompanyRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/profile/bidder/individual': {
      id: '/_app/profile/bidder/individual'
      path: '/profile/bidder/individual'
      fullPath: '/profile/bidder/individual'
      preLoaderRoute: typeof AppProfileBidderIndividualRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/projects/$id/': {
      id: '/_app/projects/$id/'
      path: '/projects/$id'
      fullPath: '/projects/$id/'
      preLoaderRoute: typeof AppProjectsIdIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/projects/$id/calendar': {
      id: '/_app/projects/$id/calendar'
      path: '/projects/$id/calendar'
      fullPath: '/projects/$id/calendar'
      preLoaderRoute: typeof AppProjectsIdCalendarRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/projects/$id/dispute': {
      id: '/_app/projects/$id/dispute'
      path: '/projects/$id/dispute'
      fullPath: '/projects/$id/dispute'
      preLoaderRoute: typeof AppProjectsIdDisputeRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/projects/$id/rating': {
      id: '/_app/projects/$id/rating'
      path: '/projects/$id/rating'
      fullPath: '/projects/$id/rating'
      preLoaderRoute: typeof AppProjectsIdRatingRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/projects/$id/tasks': {
      id: '/_app/projects/$id/tasks'
      path: '/projects/$id/tasks'
      fullPath: '/projects/$id/tasks'
      preLoaderRoute: typeof AppProjectsIdTasksRouteImport
      parentRoute: typeof AppRoute
    }
  }
}

interface AdminAdminRouteChildren {
  AdminAdminAiCostsRoute: typeof AdminAdminAiCostsRoute
  AdminAdminDelaysRoute: typeof AdminAdminDelaysRoute
  AdminAdminDisputesRoute: typeof AdminAdminDisputesRoute
  AdminAdminGhostRoute: typeof AdminAdminGhostRoute
  AdminAdminGrantsRoute: typeof AdminAdminGrantsRoute
  AdminAdminModerationRoute: typeof AdminAdminModerationRoute
  AdminAdminOverridesRoute: typeof AdminAdminOverridesRoute
  AdminAdminPromosRoute: typeof AdminAdminPromosRoute
  AdminAdminQuotasRoute: typeof AdminAdminQuotasRoute
  AdminAdminReferralsRoute: typeof AdminAdminReferralsRoute
  AdminAdminScoringRoute: typeof AdminAdminScoringRoute
  AdminAdminUsersRoute: typeof AdminAdminUsersRoute
  AdminAdminVerificationsRoute: typeof AdminAdminVerificationsRoute
  AdminAdminIndexRoute: typeof AdminAdminIndexRoute
  AdminAdminDisputesDisputeIdRoute: typeof AdminAdminDisputesDisputeIdRoute
}

const AdminAdminRouteChildren: AdminAdminRouteChildren = {
  AdminAdminAiCostsRoute: AdminAdminAiCostsRoute,
  AdminAdminDelaysRoute: AdminAdminDelaysRoute,
  AdminAdminDisputesRoute: AdminAdminDisputesRoute,
  AdminAdminGhostRoute: AdminAdminGhostRoute,
  AdminAdminGrantsRoute: AdminAdminGrantsRoute,
  AdminAdminModerationRoute: AdminAdminModerationRoute,
  AdminAdminOverridesRoute: AdminAdminOverridesRoute,
  AdminAdminPromosRoute: AdminAdminPromosRoute,
  AdminAdminQuotasRoute: AdminAdminQuotasRoute,
  AdminAdminReferralsRoute: AdminAdminReferralsRoute,
  AdminAdminScoringRoute: AdminAdminScoringRoute,
  AdminAdminUsersRoute: AdminAdminUsersRoute,
  AdminAdminVerificationsRoute: AdminAdminVerificationsRoute,
  AdminAdminIndexRoute: AdminAdminIndexRoute,
  AdminAdminDisputesDisputeIdRoute: AdminAdminDisputesDisputeIdRoute,
}

const AdminAdminRouteWithChildren = AdminAdminRoute._addFileChildren(
  AdminAdminRouteChildren,
)

interface AdminRouteChildren {
  AdminAdminRoute: typeof AdminAdminRouteWithChildren
}

const AdminRouteChildren: AdminRouteChildren = {
  AdminAdminRoute: AdminAdminRouteWithChildren,
}

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren)

interface AppDashboardRouteChildren {
  AppDashboardRequesterRoute: typeof AppDashboardRequesterRoute
  AppDashboardIndexRoute: typeof AppDashboardIndexRoute
  AppDashboardBidderBidsRoute: typeof AppDashboardBidderBidsRoute
  AppDashboardBidderCompanyRoute: typeof AppDashboardBidderCompanyRoute
  AppDashboardBidderFeedRoute: typeof AppDashboardBidderFeedRoute
  AppDashboardBidderIndividualRoute: typeof AppDashboardBidderIndividualRoute
}

const AppDashboardRouteChildren: AppDashboardRouteChildren = {
  AppDashboardRequesterRoute: AppDashboardRequesterRoute,
  AppDashboardIndexRoute: AppDashboardIndexRoute,
  AppDashboardBidderBidsRoute: AppDashboardBidderBidsRoute,
  AppDashboardBidderCompanyRoute: AppDashboardBidderCompanyRoute,
  AppDashboardBidderFeedRoute: AppDashboardBidderFeedRoute,
  AppDashboardBidderIndividualRoute: AppDashboardBidderIndividualRoute,
}

const AppDashboardRouteWithChildren = AppDashboardRoute._addFileChildren(
  AppDashboardRouteChildren,
)

interface AppSettingsRouteChildren {
  AppSettingsIdentityRoute: typeof AppSettingsIdentityRoute
  AppSettingsNotificationsRoute: typeof AppSettingsNotificationsRoute
  AppSettingsPlanRoute: typeof AppSettingsPlanRoute
  AppSettingsPrivacyRoute: typeof AppSettingsPrivacyRoute
  AppSettingsPromoRoute: typeof AppSettingsPromoRoute
  AppSettingsReferralRoute: typeof AppSettingsReferralRoute
  AppSettingsSecurityRoute: typeof AppSettingsSecurityRoute
  AppSettingsIndexRoute: typeof AppSettingsIndexRoute
}

const AppSettingsRouteChildren: AppSettingsRouteChildren = {
  AppSettingsIdentityRoute: AppSettingsIdentityRoute,
  AppSettingsNotificationsRoute: AppSettingsNotificationsRoute,
  AppSettingsPlanRoute: AppSettingsPlanRoute,
  AppSettingsPrivacyRoute: AppSettingsPrivacyRoute,
  AppSettingsPromoRoute: AppSettingsPromoRoute,
  AppSettingsReferralRoute: AppSettingsReferralRoute,
  AppSettingsSecurityRoute: AppSettingsSecurityRoute,
  AppSettingsIndexRoute: AppSettingsIndexRoute,
}

const AppSettingsRouteWithChildren = AppSettingsRoute._addFileChildren(
  AppSettingsRouteChildren,
)

interface AppRouteChildren {
  AppDashboardRoute: typeof AppDashboardRouteWithChildren
  AppNotificationsRoute: typeof AppNotificationsRoute
  AppSettingsRoute: typeof AppSettingsRouteWithChildren
  AppOffersNewRoute: typeof AppOffersNewRoute
  AppOffersIndexRoute: typeof AppOffersIndexRoute
  AppProjectsIndexRoute: typeof AppProjectsIndexRoute
  AppBidsBidIdDecisionRoute: typeof AppBidsBidIdDecisionRoute
  AppOffersIdBidRoute: typeof AppOffersIdBidRoute
  AppOffersIdEditRoute: typeof AppOffersIdEditRoute
  AppOffersIdSelectionRoute: typeof AppOffersIdSelectionRoute
  AppProfileBidderCompanyRoute: typeof AppProfileBidderCompanyRoute
  AppProfileBidderIndividualRoute: typeof AppProfileBidderIndividualRoute
  AppProjectsIdCalendarRoute: typeof AppProjectsIdCalendarRoute
  AppProjectsIdDisputeRoute: typeof AppProjectsIdDisputeRoute
  AppProjectsIdRatingRoute: typeof AppProjectsIdRatingRoute
  AppProjectsIdTasksRoute: typeof AppProjectsIdTasksRoute
  AppOffersIdIndexRoute: typeof AppOffersIdIndexRoute
  AppProjectsIdIndexRoute: typeof AppProjectsIdIndexRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppDashboardRoute: AppDashboardRouteWithChildren,
  AppNotificationsRoute: AppNotificationsRoute,
  AppSettingsRoute: AppSettingsRouteWithChildren,
  AppOffersNewRoute: AppOffersNewRoute,
  AppOffersIndexRoute: AppOffersIndexRoute,
  AppProjectsIndexRoute: AppProjectsIndexRoute,
  AppBidsBidIdDecisionRoute: AppBidsBidIdDecisionRoute,
  AppOffersIdBidRoute: AppOffersIdBidRoute,
  AppOffersIdEditRoute: AppOffersIdEditRoute,
  AppOffersIdSelectionRoute: AppOffersIdSelectionRoute,
  AppProfileBidderCompanyRoute: AppProfileBidderCompanyRoute,
  AppProfileBidderIndividualRoute: AppProfileBidderIndividualRoute,
  AppProjectsIdCalendarRoute: AppProjectsIdCalendarRoute,
  AppProjectsIdDisputeRoute: AppProjectsIdDisputeRoute,
  AppProjectsIdRatingRoute: AppProjectsIdRatingRoute,
  AppProjectsIdTasksRoute: AppProjectsIdTasksRoute,
  AppOffersIdIndexRoute: AppOffersIdIndexRoute,
  AppProjectsIdIndexRoute: AppProjectsIdIndexRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

interface AuthRouteChildren {
  AuthCheckEmailRoute: typeof AuthCheckEmailRoute
  AuthForgotPasswordRoute: typeof AuthForgotPasswordRoute
  AuthOauthCompleteRoute: typeof AuthOauthCompleteRoute
  AuthResetPasswordRoute: typeof AuthResetPasswordRoute
  AuthSignInRoute: typeof AuthSignInRoute
  AuthSignUpRoute: typeof AuthSignUpRoute
  AuthVerifyEmailRoute: typeof AuthVerifyEmailRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthCheckEmailRoute: AuthCheckEmailRoute,
  AuthForgotPasswordRoute: AuthForgotPasswordRoute,
  AuthOauthCompleteRoute: AuthOauthCompleteRoute,
  AuthResetPasswordRoute: AuthResetPasswordRoute,
  AuthSignInRoute: AuthSignInRoute,
  AuthSignUpRoute: AuthSignUpRoute,
  AuthVerifyEmailRoute: AuthVerifyEmailRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AdminRoute: AdminRouteWithChildren,
  AppRoute: AppRouteWithChildren,
  AuthRoute: AuthRouteWithChildren,
  AgencySlugRoute: AgencySlugRoute,
  QuotesIdVerifyRoute: QuotesIdVerifyRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
